import { SxProps, Theme } from '@mui/system';

const styles = {
  root: {
    padding: '15px 20px 32px 20px',
    overflow: 'hidden',
  },

  container: {
    display: 'flex',
  },

  avatar: {
    height: 100,
    width: 100,
  },

  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 24px 24px 24px',
  },

  input: {
    display: 'none',
  },

  chooseFileButton: {
    paddingBottom: '12px',
  },

  submitButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },

  buttonWidth: {
    // width: 140,
  },

  messageFont: {
    fontSize: 12,
    color: 'grey.500',
    whiteSpace: 'pre-line',
  },

  errorFont: {
    fontSize: 12,
    color: 'common.error',
  },

  buttonContainer: {
    display: 'flex',
  },

  fileNameFont: {
    fontWeight: 500,
    maxWidth: '100px',
    textOverflow: 'ellipsis',
    paddingRight: '20px',
  },

  iconButton: {
    padding: 0,
    ml: '2px',
    marginBottom: '6px',
  },

  crossIcon: {
    height: 14,
    width: 14,
    color: 'common.gray',
  },

  imageName: {
    color: 'grey.500',
    fontSize: 14,
    fontWeight: 400,
    textDecorationLine: 'underline',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
